import React from 'react';
import './ClinicInfoText.css';
import {
    ClinicInfoPanel,
    ClinicInfoDetailItem,
    VerificationBadge,
    ClinicStatusCard,
    ClinicLogoCard,
    VerificationSummaryCard,
    ClinicTimezoneCard,
} from './clinicInfoParts';

const ClinicInfoText = ({ clinicInfo, logoDimensions }) => {
    const isActive = clinicInfo?.status === 'ON';
    const addressLines = [
        clinicInfo?.street,
        [clinicInfo?.city, clinicInfo?.province, clinicInfo?.postalCode].filter(Boolean).join(', '),
        clinicInfo?.country,
    ].filter(Boolean);

    return (
        <div className="clinic-info-view">
            <div className="row g-3">
                <div className="col-lg-8">
                    <ClinicInfoPanel title="Basic Information" icon="bi-info-circle">
                        <div className="clinic-info-detail-grid">
                            <ClinicInfoDetailItem label="Clinic Name" value={clinicInfo?.name} />
                            <ClinicInfoDetailItem label="Clinic Number" value={clinicInfo?.number} />
                            <ClinicInfoDetailItem label="Clinic Type" value={clinicInfo?.clinicType} />
                            <ClinicInfoDetailItem label="Date Started" value={clinicInfo?.dateStarted} />
                            <ClinicInfoDetailItem
                                label="Clinic Signature"
                                value={clinicInfo?.signature}
                                className="clinic-info-detail-item--full"
                            />
                        </div>
                    </ClinicInfoPanel>
                </div>

                <div className="col-lg-4">
                    <div className="clinic-info-aside">
                        <ClinicStatusCard isActive={isActive} />
                        <ClinicLogoCard logo={clinicInfo?.logo} logoDimensions={logoDimensions} />
                    </div>
                </div>
            </div>

            <div className="row g-3">
                <div className="col-lg-8">
                    <ClinicInfoPanel title="Contact Information" icon="bi-telephone">
                        <div className="clinic-info-detail-grid">
                            <ClinicInfoDetailItem label="Email">
                                {clinicInfo?.email ? (
                                    <a href={`mailto:${clinicInfo.email}`} className="clinic-info-link">
                                        {clinicInfo.email}
                                    </a>
                                ) : (
                                    '—'
                                )}
                                <VerificationBadge
                                    isVerified={clinicInfo?.verification?.email}
                                    fieldName="Email"
                                />
                            </ClinicInfoDetailItem>

                            <ClinicInfoDetailItem label="Phone">
                                {clinicInfo?.phone ? (
                                    <a href={`tel:${clinicInfo.phone}`} className="clinic-info-link">
                                        {clinicInfo.phone}
                                    </a>
                                ) : (
                                    '—'
                                )}
                                <VerificationBadge
                                    isVerified={clinicInfo?.verification?.phone}
                                    fieldName="Phone"
                                />
                            </ClinicInfoDetailItem>

                            <ClinicInfoDetailItem label="SMS">
                                <span>{clinicInfo?.sms || '—'}</span>
                                <VerificationBadge
                                    isVerified={clinicInfo?.verification?.sms}
                                    fieldName="SMS"
                                />
                            </ClinicInfoDetailItem>

                            <ClinicInfoDetailItem label="Website">
                                {clinicInfo?.website ? (
                                    <a
                                        href={clinicInfo.website}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="clinic-info-link"
                                    >
                                        {clinicInfo.website}
                                    </a>
                                ) : (
                                    '—'
                                )}
                            </ClinicInfoDetailItem>
                        </div>
                    </ClinicInfoPanel>
                </div>

                <div className="col-lg-4">
                    <VerificationSummaryCard verification={clinicInfo?.verification} />
                </div>
            </div>

            <div className="row g-3">
                <div className="col-lg-8">
                    <ClinicInfoPanel title="Address" icon="bi-geo-alt">
                        {addressLines.length > 0 ? (
                            <div className="clinic-info-address">
                                {addressLines.map((line) => (
                                    <span key={line} className="clinic-info-address__line">
                                        {line}
                                    </span>
                                ))}
                            </div>
                        ) : (
                            <span className="text-muted">—</span>
                        )}
                    </ClinicInfoPanel>
                </div>

                <div className="col-lg-4">
                    <ClinicTimezoneCard timezoneName={clinicInfo?.timezone?.timezoneName} />
                </div>
            </div>
        </div>
    );
};

export default ClinicInfoText;
